
import React, { Component } from 'react';

import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import { ReactComponent as DoiIcon } from './doi.svg';
import { ReactComponent as BibIcon } from './bibtex.svg';

import ErrorMessage from './cmpErrorMessage'

//-------------------------------------------------------------------------------------------------------------------------------------------------------------

function Doi(props) {
  const [doi] = React.useState(props.value);
  return (
    <Tooltip title={doi}>
      <IconButton size='small' disableFocusRipple={true} onClick={() => { window.open('https://www.doi.org' + (doi.startsWith('/') ? '' : '/') + doi); }}>
        <DoiIcon style={{ width: '24px', height: '24px' }} />
      </IconButton>
    </Tooltip>)
}

//-------------------------------------------------------------------------------------------------------------------------------------------------------------

class BibRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      addr: props.addr,
      record: undefined
    };
  }

  componentDidMount() {
    fetch(process.env.PUBLIC_URL + this.state.addr)
      .then(response => {
        if (!response.ok)
          throw Error('./' + response.statusText);
        return response;
      })
      .then((r) => r.text())
      .then(text => {
        this.setState({
          isLoading: false,
          record: text
        })
      })
  }

  render() {
    if (this.state.isLoading) {
      return <table>
        <tbody>
          <tr>
            <td align='center' valign='middle' width='200px' height='100px'>
              <CircularProgress />
            </td>
          </tr>
        </tbody>
      </table>
    }
    return (
      <DialogContent>
        <pre style={{
          overflowX: 'auto',
          whiteSpace: 'pre-wrap ',
          wordWrap: 'break-word'
        }}>{this.state.record}</pre>
      </DialogContent>)
  }
}

function BibTex(props) {
  const [addr] = React.useState(props.value);
  const [opened, setOpen] = React.useState(false)
  return (
    <div style={{ display: 'inline' }}>
      <Tooltip title='Show Bibliography Record'>
        <IconButton size='small' disableFocusRipple={true} onClick={() => { setOpen(true) }}>
          <BibIcon style={{ width: '24px', height: '24px' }} />
        </IconButton>
      </Tooltip>
      <Dialog open={opened} fullWidth={true} maxWidth='md' onClose={() => { setOpen(false) }}>
        <BibRecord addr={addr} />
      </Dialog>
    </div>)
}

//-------------------------------------------------------------------------------------------------------------------------------------------------------------

export default class Publications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      papers: undefined,
      failedMsg: undefined
    };
  }

  componentDidMount() {
    fetch(process.env.PUBLIC_URL + '/bibliographies/papers.json')
      .then(response => {
        if (!response.ok)
          throw Error('./' + response.statusText);
        return response;
      })
      .then((r) => r.json())
      .then(js => {
        this.setState({
          isLoading: false,
          papers: js.papers
        })
      })
      .catch(e => this.setState({
        isLoading: false,
        failedMsg: e
      }))
  }

  transform = (paper, index) => {
    var name = paper.name
    var authors = paper.authors
    var address = paper.address
    var doi = paper.doi
    var bib = paper.bibtex
    if (name) {
      name = name.trim()
      name = name.endsWith(".") ? name : name + "."
    }
    if (authors) {
      authors = authors.trim()
      authors = authors.endsWith(".") ? authors : authors + "."
    }
    if (address) {
      address = address.trim()
      address = address.endsWith(".") ? address : address + "."
    }
    return <tr key={index}>
      <td valign='top'>{index + 1}.</td>
      <td style={{ paddingBottom: '1em' }}>
        {authors}{' '}
        <b>{name}</b>{' '}
        {address}{' '}
        {!doi ? '' : <Doi value={doi} />}
        {!bib ? '' : <BibTex value={bib} />}
        {name ? '' : <ErrorMessage msg='Paper name is not given' />}
        {authors ? '' : <ErrorMessage msg='Authors are not given' />}
        {address ? '' : <ErrorMessage msg='Address is not given' />}
      </td>
    </tr>;
  };

  render = () => {
    return (
      <Typography component="div" papers={this.state.papers} style={{ padding: 8 * 3 }}>
        {
          this.state.failedMsg ? <ErrorMessage msg={'Error in loading publication records.'} extra={this.state.failedMsg.toString()} /> :
            this.state.isLoading ?
              <table style={{ margin: 'auto' }}>
                <tbody>
                  <tr>
                    <td><CircularProgress /></td>
                  </tr>
                </tbody>
              </table> :
              <table>
                <tbody>
                  {this.state.papers.map(this.transform)}
                </tbody>
              </table>
        }
      </Typography>)
  };
}